import script from "./Sp2Results.vue?vue&type=script&setup=true&lang=js"
export * from "./Sp2Results.vue?vue&type=script&setup=true&lang=js"

import "./Sp2Results.vue?vue&type=style&index=0&id=5eaf3aca&lang=postcss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eaf3aca"]])

export default __exports__